import React from 'react';
import { Play, Wind, Sparkles, Clock, Heart, Star } from 'lucide-react';
import { greetingByHour } from '../data/mock';

const Hero = ({ featured, onPlayFeatured, onStartBreath }) => {
  return (
    <section id="hero" className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-emerald-50/60 via-white to-white" />
      <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-emerald-200/30 blur-3xl -z-10" />
      <div className="absolute top-40 -right-20 w-96 h-96 rounded-full bg-emerald-100/40 blur-3xl -z-10" />

      <div className="max-w-7xl mx-auto px-4 py-10 sm:py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white px-3 py-1 text-xs sm:text-sm text-emerald-800 shadow-sm">
            <Sparkles className="w-3.5 h-3.5 text-emerald-600" />
            {greetingByHour()} <span className="text-emerald-400">•</span> Peace begins here
          </span>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-emerald-950">
            Elevate Your Mind,<br />
            <em className="italic text-emerald-800">Win Your Day.</em>
          </h1>
          <p className="mt-5 text-emerald-900/80 text-base sm:text-lg max-w-xl leading-relaxed">
            Handcrafted guided audio and video meditations &amp; daily positive affirmations in <strong>English</strong> and <strong>Hindi (हिंदी)</strong> created to relieve stress, deepen sleep, and empower your inner strength.
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <button
              onClick={onPlayFeatured}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-700 text-white shadow-md shadow-emerald-200 hover:bg-emerald-800 hover:-translate-y-0.5 transition-all"
            >
              <Play className="w-4 h-4 fill-white" /> Play Featured Session
            </button>
            <button
              onClick={onStartBreath}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-emerald-300 text-emerald-800 hover:bg-emerald-50 hover:-translate-y-0.5 transition-all"
            >
              <Wind className="w-4 h-4" /> Start Guided Breathing
            </button>
          </div>

          <blockquote className="mt-8 border-l-4 border-emerald-300 pl-5 max-w-md">
            <p className="font-serif italic text-emerald-900/85 text-lg">"Quiet the mind, and the soul will speak."</p>
            <footer className="text-xs text-emerald-700 mt-1">— Ma Jaya Sati Bhagavati</footer>
          </blockquote>
        </div>

        {featured && (
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl shadow-emerald-900/10 border border-emerald-100 bg-white">
              <div className="relative aspect-[16/10]">
                <img src={featured.image} alt={featured.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-medium text-emerald-800">
                  <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
                  Featured Meditation ({featured.langFlag} {featured.language})
                </span>
                <button
                  onClick={onPlayFeatured}
                  className="absolute inset-0 m-auto w-16 h-16 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
                  aria-label="Play featured"
                >
                  <Play className="w-6 h-6 fill-emerald-700 text-emerald-700 ml-1" />
                </button>
              </div>
              <div className="p-5">
                <h3 className="font-serif text-xl text-emerald-950 leading-snug">{featured.title}</h3>
                <p className="mt-2 text-sm text-emerald-900/75">{featured.description}</p>
                <div className="mt-4 flex items-center gap-4 text-xs text-emerald-800">
                  <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {featured.duration} mins</span>
                  <span className="inline-flex items-center gap-1"><Play className="w-3.5 h-3.5" /> {featured.plays} plays</span>
                  <span className="inline-flex items-center gap-1"><Heart className="w-3.5 h-3.5" /> {featured.likes} likes</span>
                  <span className="inline-flex items-center gap-1 ml-auto"><Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" /> {featured.rating.toFixed(1)} ({featured.reviews})</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
